import { render, staticRenderFns } from "./Guest_terms.vue?vue&type=template&id=08ad4e76&"
import script from "./Guest_terms.vue?vue&type=script&lang=js&"
export * from "./Guest_terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports